export var useApplication = function (controller) {
    // getter to detect Turbolink preview
    Object.defineProperty(controller, 'isPreview', {
        get: function () {
            return document.documentElement.hasAttribute('data-turbolinks-preview');
        },
    });
    // getter to get the csrf token
    Object.defineProperty(controller, 'csrfToken', {
        get: function () {
            return this.metaValue('csrf-token');
        },
    });
    Object.assign(controller, {
        dispatch: function (eventName, _a) {
            var _b = _a === void 0 ? {} : _a, _c = _b.target, target = _c === void 0 ? controller.element : _c, _d = _b.detail, detail = _d === void 0 ? {} : _d, _e = _b.bubbles, bubbles = _e === void 0 ? true : _e, _f = _b.cancelable, cancelable = _f === void 0 ? true : _f;
            // include the emitting controller in the event detail
            Object.assign(detail, { controller: controller });
            var type = controller.identifier + ":" + eventName;
            var event = new CustomEvent(type, {
                detail: detail,
                bubbles: bubbles,
                cancelable: cancelable,
            });
            target.dispatchEvent(event);
            return event;
        },
        metaValue: function (name) {
            var element = document.head.querySelector("meta[name=\"" + name + "\"]");
            return element && element.getAttribute('content');
        },
    });
};
//# sourceMappingURL=use-application.js.map